import { initializeTracing } from '@imprivata-cloud/common';
import { getApiUrl } from '../api/utils';
import { StorageKeys } from '../api/constants';
import { isSetup } from './utils';
import type { TracerProvider } from '@opentelemetry/api';

interface Tracing {
  serviceName: string;
  getTracer: () => void;
  getProvider: () => TracerProvider;
  getWorkflowId: () => string;
  updateWorkflowId: (id: string) => void;
}

export let tracer: Tracing;

//  if page is refreshed in the middle of the setup, you keep the workflowId
if (getWorkflowId() && isSetup()) {
  initTracerSetup(getWorkflowId());
}

export function getWorkflowId(): string {
  return sessionStorage.getItem(StorageKeys.WORKFLOW_ID) || '';
}

export function initTracerSetup(workflowId: string) {
  initTracer('setup-ui', workflowId);
}

export function initTracerPortal(workflowId: string) {
  initTracer('portal-ui', workflowId);
}

export function initTracer(serviceName: string, workflowId: string) {
  const apiUrl = getApiUrl();
  tracer = initializeTracing({
    serviceName,
    workflowId,
    OTLP_TRACING_URL: `${apiUrl}/v1/traces`
  });
}

